export default __webpack_public_path__ + "static/media/6.be07b6f8.jpg";